<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="boviclic-container">
  <div class="ibox">
    <div class="ibox-head justify-content-center">
      <div class="ibox-title text-uppercase text-center" i18n="@@boviclicTitle">
        Removal request from Boviclic to validate
      </div>
    </div>

    <div class="ibox-body">
      <form [formGroup]="removalFG" #rForm="ngForm" (ngSubmit)="removalFormSubmit()">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <div class="ibox">
              <div class="ibox-head">
                <div class="ibox-title text-uppercase" i18n="@@headquarter">Headquarters</div>
              </div>

              <div class="ibox-body">
                <div class="row">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <app-display-removal-point-details [data]="hq"></app-display-removal-point-details>
                  </div>

                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <app-input-phone-numbers [removalPoint]="hq" [allowAdd]="true" [allowRemove]="true"
                                                 [showRequired]="false">
                        </app-input-phone-numbers>
                      </div>

                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                        <app-input-phone-numbers [removalPoint]="hq" [allowAdd]="true" [allowRemove]="true"
                                                 [showRequired]="false" [mobilePhones]="true"></app-input-phone-numbers>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <div class="ibox">
              <div class="ibox-head">
                <div class="ibox-title text-uppercase" i18n="@@removalPoint">Removal point</div>
              </div>

              <div class="ibox-body">
                <div class="row" *ngIf="rp">
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <app-display-removal-point-details [fontBold]="true"
                                                       [data]="rp"></app-display-removal-point-details>
                  </div>

                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                    <div class="row">
                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <app-input-phone-numbers [removalPoint]="rp" [allowAdd]="true" [allowRemove]="true"
                                                 [showRequired]="false">
                        </app-input-phone-numbers>
                      </div>

                      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2">
                        <app-input-phone-numbers [removalPoint]="rp" [allowAdd]="true" [allowRemove]="true"
                                                 [mobilePhones]="true" [showRequired]="false"></app-input-phone-numbers>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" [class.mt-4]="rp">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                    <app-select-removal-points controlName="removalPoint" [thirdParty]="tp" [formGroup]="removalFG"
                                               (updated)="rpChange($event)" [submitted]="rForm.submitted">
                    </app-select-removal-points>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-input-comments controlName="comments" [showLabel]="true" [formGroup]="removalFG"
                                [submitted]="rForm.submitted"></app-input-comments>
          </div>
        </div>

        <div class="row mt-2">
          <div class="form-group col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-table-boviclic-animals controlName="animals" [formGroup]="removalFG" [ids]="animalIds"
                                        [submitted]="rForm.submitted"></app-table-boviclic-animals>
          </div>
        </div>

        <div class="row mt-2" *ngIf="tp?.cso">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <app-display-third-party-cso></app-display-third-party-cso>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <button type="reset" class="btn btn-danger btn-rounded btn-block" i18n="@@cancel" (click)="cancel()">
              Cancel
            </button>
          </div>

          <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mt-md-0 mt-xl-0 mt-xl-0">
            <button type="submit" class="btn btn-success btn-rounded btn-block" i18n="@@validate">
              Validate
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
